module.exports = __webpack_public_path__ + "files/f57758b43b98b6f5b71bcf865d4b0c0f.png";